import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ForceDirection, HtmlEditorOptions, InputType, TextBoxOptions } from 'bnsights-control-library';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { ClipboardService } from 'ngx-clipboard';
import { PageInfoService } from '../../../_metronic/core/services/page-info.service';
import { DataSecretService } from '../../shared/Services/data.service';
import { TemplateService } from '../../shared/Services/TemplateService.service';
import { TemplateEditViewModel } from './../../shared/models/NotificationsModels/TemplateEditViewModel';
import { AuthService, UtilityService, BBSFTranslateService, EnvironmentService } from 'bnsights-utilities-library';

@Component({
  selector: 'lib-edit-email',
  templateUrl: './edit-email.component.html'
})
export class EditEmailComponent implements OnInit {
  PageName: string = ""
  TemplateId: string = ""
  Lang: string = ""
  TemplateInfo: any
  IsAEditFormLoaded:boolean

  EditEmailForm = new FormGroup({});
  EmailSubjectInEnglish: TextBoxOptions;
  EmailBodyInEnglish: HtmlEditorOptions;
  HtmlBodyTagAttributesEnglish: TextBoxOptions;
  HTMLHeadSectionInEnglish: TextBoxOptions;

  EmailSubjectInArabic: TextBoxOptions;
  EmailBodyInArabic: HtmlEditorOptions;
  HtmlBodyTagAttributesArabic: TextBoxOptions;
  HTMLHeadSectionInArabic: TextBoxOptions;
  // Decorator wires up blockUI instance
  @BlockUI() blockUI: NgBlockUI;
  language:string=""

  constructor(private pageInfoService:PageInfoService, private authService:AuthService, public utilityService:UtilityService,private bbsfTranslateService:BBSFTranslateService,private environmentService:EnvironmentService,private _clipboardService: ClipboardService, private dataServices: DataSecretService, private templateService: TemplateService, private activatedRoute: ActivatedRoute, private router: Router) {
    this.activatedRoute.params.subscribe(params => {
      this.TemplateId = params['id'];
      this.Lang = params['lang'];
    });
  }

  async ngOnInit(): Promise<void> {
    this.IsAEditFormLoaded=false

    this.bbsfTranslateService.onLangChange.subscribe((event)=>{
      this.language = event.lang;
      this.ngOnInit();
    })
    this.language = await this.utilityService.getCurrentLanguage();
    this.templateService.GetTemplateInfoByLang( Number(this.TemplateId), this.Lang).subscribe((result) => {
      let Result: any = result
      this.TemplateInfo = Result.val;
        let TemplateName:string= this.language=='en'?this.TemplateInfo.emailtemplateinfo.emailSubject.english:this.TemplateInfo.emailtemplateinfo.emailSubject.arabic
       if(TemplateName==null||TemplateName==undefined)
       TemplateName=""
        PageInfoService.PageTitle=this.utilityService.getResourceValue("Edit")
        PageInfoService.PageBreadcrumbs=[
         {title: this.utilityService.getResourceValue("Home") , path: '/Admin/Home', isSeparator: false, isActive: false},
         {title: '', path: '', isSeparator: true, isActive: false},
         {title: this.utilityService.getResourceValue("Templates"), path: '/Admin/Notifications/Templates', isSeparator: false, isActive: false},
         {title: '', path: '', isSeparator: true, isActive: false},
         {title:TemplateName!=""?this.utilityService.getResourceValue(TemplateName):"" , path: "/Admin/Notifications/TemplateInfo/"+this.TemplateInfo.id, isSeparator: false, isActive: false},
         {title: '', path: '', isSeparator: true, isActive: false}
  
  
      ];
      this.pageInfoService.calculateTitle();
      this.pageInfoService.calculateBreadcrumbs();
      
      this.EmailBodyInEnglish = new HtmlEditorOptions();
      this.EmailBodyInEnglish.Name = "EmailBodyInEnglish"
      this.EmailBodyInEnglish.LabelKey = "EmailBodyInEnglish"
      this.EmailBodyInEnglish.IsRequired = true
      this.EmailBodyInEnglish.Value = this.TemplateInfo.emailtemplateinfo.emailBody.english;
    

      this.EmailBodyInArabic = new HtmlEditorOptions();
      this.EmailBodyInArabic.Name = "EmailBodyInArabic"
      this.EmailBodyInArabic.LabelKey = "EmailBodyInArabic"
      this.EmailBodyInArabic.IsRequired = true
      this.EmailBodyInArabic.ForceDirection = ForceDirection.Arabic
      this.EmailBodyInArabic.Value = this.TemplateInfo.emailtemplateinfo.emailBody.arabic;


      this.EmailSubjectInEnglish = new TextBoxOptions();
      this.EmailSubjectInEnglish.Name = "EmailSubjectInEnglish"
      this.EmailSubjectInEnglish.LabelValue = "EmailSubjectInEnglish"
      this.EmailSubjectInEnglish.LabelKey = "EmailSubjectInEnglish"
      this.EmailSubjectInEnglish.Type = InputType.Text
      this.EmailSubjectInEnglish.Value = this.TemplateInfo.emailtemplateinfo.emailSubject.english;

      this.EmailSubjectInArabic = new TextBoxOptions();
      this.EmailSubjectInArabic.Name = "EmailSubjectInArabic"
      this.EmailSubjectInArabic.LabelKey = "EmailSubjectInArabic"
      this.EmailSubjectInArabic.Type = InputType.Text
      this.EmailSubjectInArabic.ForceDirection = ForceDirection.Arabic
      this.EmailSubjectInArabic.Value = this.TemplateInfo.emailtemplateinfo.emailSubject.arabic;

     this.HtmlBodyTagAttributesEnglish = new TextBoxOptions();
      this.HtmlBodyTagAttributesEnglish.Name = "HtmlBodyTagAttributesEnglish"
      this.HtmlBodyTagAttributesEnglish.LabelKey = "HtmlBodyTagAttributesEnglish"
      this.HtmlBodyTagAttributesEnglish.Type = InputType.Text
      this.HtmlBodyTagAttributesEnglish.Value = this.TemplateInfo.emailtemplateinfo.emailHtmlBodyTagAttributes.english;

      this.HtmlBodyTagAttributesArabic = new TextBoxOptions();
      this.HtmlBodyTagAttributesArabic.Name = "HtmlBodyTagAttributesArabic"
      this.HtmlBodyTagAttributesArabic.LabelKey = "HtmlBodyTagAttributesArabic"
      this.HtmlBodyTagAttributesArabic.Type = InputType.Text
      this.HtmlBodyTagAttributesArabic.ForceDirection = ForceDirection.Arabic
      this.HtmlBodyTagAttributesArabic.Value = this.TemplateInfo.emailtemplateinfo.emailHtmlBodyTagAttributes.arabic;


      this.HTMLHeadSectionInEnglish = new TextBoxOptions();
      this.HTMLHeadSectionInEnglish.Name = "HTMLHeadSectionInEnglish"
      this.HTMLHeadSectionInEnglish.LabelKey = "HTMLHeadSectionInEnglish"
      this.HTMLHeadSectionInEnglish.Type = InputType.Text
      this.HTMLHeadSectionInEnglish.Value = this.TemplateInfo.emailtemplateinfo.emailHtmlHeadSection.english;

      this.HTMLHeadSectionInArabic = new TextBoxOptions();
      this.HTMLHeadSectionInArabic.Name = "HTMLHeadSectionInArabic"
      this.HTMLHeadSectionInArabic.LabelKey = "HTMLHeadSectionInArabic"
      this.HTMLHeadSectionInArabic.Type = InputType.Text
      this.HTMLHeadSectionInArabic.ForceDirection = ForceDirection.Arabic
      this.HTMLHeadSectionInArabic.Value = this.TemplateInfo.emailtemplateinfo.emailHtmlHeadSection.arabic;
      this.IsAEditFormLoaded=true;
    });
  }

 changeCurrentLanguage(lang:string)
 {
   this.Lang=lang;
 }

  
  editEmailTemplate(){
    if (this.EditEmailForm.invalid) {
      return;
    }
    else {
      let ResultModel = this.EditEmailForm.value;
      let EmailTemplateModel = new TemplateEditViewModel();
      EmailTemplateModel.ID = Number(this.TemplateId);
      EmailTemplateModel.IDEncrypted = this.TemplateInfo.idEncrypted;
      EmailTemplateModel.IsEmail = this.TemplateInfo.isEmail;
      EmailTemplateModel.IsSms = this.TemplateInfo.isSms;
      EmailTemplateModel.TemplateName = this.TemplateInfo.templateName;
      EmailTemplateModel.Language = this.Lang;
      EmailTemplateModel.emailtemplateinfo.ID =this.TemplateInfo.emailtemplateinfo.id ;
      EmailTemplateModel.emailtemplateinfo.EmailBody.Arabic = ResultModel.EmailBodyInArabic
      EmailTemplateModel.emailtemplateinfo.EmailBody.English = ResultModel.EmailBodyInEnglish
      EmailTemplateModel.emailtemplateinfo.EmailSubject.Arabic = ResultModel.EmailSubjectInArabic
      EmailTemplateModel.emailtemplateinfo.EmailSubject.English = ResultModel.EmailSubjectInEnglish
      EmailTemplateModel.emailtemplateinfo.EmailHtmlBodyTagAttributes.Arabic = ResultModel.HtmlBodyTagAttributesArabic
      EmailTemplateModel.emailtemplateinfo.EmailHtmlBodyTagAttributes.English =ResultModel.HtmlBodyTagAttributesEnglish
      EmailTemplateModel.emailtemplateinfo.EmailHtmlHeadSection.Arabic = ResultModel.HTMLHeadSectionInArabic
      EmailTemplateModel.emailtemplateinfo.EmailHtmlHeadSection.English = ResultModel.HTMLHeadSectionInEnglish

      this.templateService.EditEmailTemplateByLang( EmailTemplateModel).subscribe((result) => {

      
         ;
        this.EditEmailForm.reset()
        this.close();
      }, (error) => {
       
      })
    }
  }
  close(){
    this.router.navigate(['/Admin/Notifications/TemplateInfo',this.TemplateId]);
  }

}
